import { AxiosResponse } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { $axios } from './axios'
import { InboxNewsArticleContentType } from '../../server/models/InboxNewsArticleContent'

export const getNewsArticleContent = (
  inboxId: string,
  articleId: string
): Promise<AxiosResponse<InboxNewsArticleContentType>> => {
  return $axios.get(`/inboxes/${inboxId}/news-articles/${articleId}/content`)
}

export const useNewsArticleContentQuery = (
  inboxId: string,
  articleId: string,
  options?: Omit<UseQueryOptions<InboxNewsArticleContentType, Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<InboxNewsArticleContentType, Error>({
    queryKey: ['sourceContent', inboxId, articleId],
    queryFn: async () => {
      const res = await getNewsArticleContent(inboxId, articleId)
      return res.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - liberal caching
    gcTime: 60 * 60 * 1000, // 1 hour - keep in cache for a long time
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options
  })
}
